<template>
  <div class="m-image-banner">
    <div class="container">
      <div class="row">
        <div
          class="col-sm-4"
          :class="{ 'order-2': content.nzSettingSmallImageRight }"
        >
          <base-image
            v-if="content.smallImage && content.smallImage[0]"
            :url="content.smallImage[0].url"
            :width="444"
            :height="390"
            :alt-text="content.smallImageAltText"
            class="m-image-banner__figure -small"
            image-class="m-image-banner__image"
          />
        </div>
        <div
          class="col-sm-8"
          :class="{ 'order-1': content.nzSettingSmallImageRight }"
        >
          <base-image
            v-if="content.largeImage && content.largeImage[0]"
            :url="content.largeImage[0].url"
            :width="909"
            :height="390"
            :alt-text="content.largeImageAltText"
            class="m-image-banner__figure -large"
            image-class="m-image-banner__image"
          />
        </div>
      </div>
      <breadcrumb v-if="isFirst" />
    </div>
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';
import BaseImage from '@/components/atoms/BaseImage';
import Breadcrumb from '@/components/molecules/Breadcrumb';

export default {
  name: 'ImageBanner',
  components: {
    BaseImage,
    Breadcrumb,
  },
  mixins: [contentMixin],
  props: {
    isFirst: {
      default: false,
      type: Boolean
    }
  },
};
</script>
